/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Label_TitleInputs */

const es_cap_label_title = /** @type {(inputs: Cap_Label_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titulación`)
};

const gl_cap_label_title = /** @type {(inputs: Cap_Label_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titulación`)
};

const en_cap_label_title = /** @type {(inputs: Cap_Label_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Licence`)
};

/**
* | output |
* | --- |
* | "Licence" |
*
* @param {Cap_Label_TitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const cap_label_title = /** @type {((inputs?: Cap_Label_TitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Label_TitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_cap_label_title(inputs)
	if (locale === "en") return en_cap_label_title(inputs)
	return es_cap_label_title(inputs)
});